import React, {Component} from 'react';
import './NewsCard.css';
import ReactGA from 'react-ga';

class NewsCard extends Component {
	constructor() {
		super();

		this.click = () => {
			ReactGA.event({
				category: 'News',
				action: 'News link'
			});
		};
	}

	render() {
		const {href, thumbnailSrc, title, vendor, formattedDate, description} = this.props;

		return (
			<a
				className="NewsCard"
				href={href}
				target="_blank"
				rel="noopener noreferrer"
				onMouseDown={this.click}
				title={`${vendor} | ${title}`}>
				<div className="NewsCard-header">
					<div className="NewsCard-thumbnail">
						<img src={thumbnailSrc} alt="Startup News" />
					</div>
					<div className="NewsCard-details">
						<div className="NewsCard-details-title">{title}</div>
						<div className="NewsCard-details-vendor">{vendor}</div>
						<div className="NewsCard-details-date">{formattedDate}</div>
					</div>
				</div>
				<div className="NewsCard-description">{description}</div>
			</a>
		);
	}
}

export default NewsCard;



// WEBPACK FOOTER //
// ./src/home/NewsCard.js